<template>
  <van-tree-select
      v-model:main-active-index="activeIndex"
      height="calc(100vh - 116px)"
      :items="itemList"
      @click-nav="clickNav"
      ref="treeList"
  >
    <template #content>
      <BookBlock :list="catalogList" @onLoad="onLoad" ref="bookChild"/>
    </template>
  </van-tree-select>
  <!--筛选按钮-->
  <div class="filter-btn" @click="showFilterPopup = true"><i class="iconfont icon-shaixuan"></i></div>
  <!--筛选弹出层-->
	<FilterPopup ref='filterPopup' v-model:show="showFilterPopup" :facet-list="facetList" @filterParams="getFilterParams"/>
</template>

<script>
import {defineComponent, ref, computed, watch, onActivated} from 'vue';
import BookBlock from './BookBlock';
import {FilterPopup} from '../components/common';
import {isNotEmpty, setCovers} from '@/utils/util';
import {getClasses, browse} from '@/api/books';
import {onBeforeRouteLeave, useRoute} from "vue-router";

export default defineComponent({
  name: 'CatalogList',
  components: {
    BookBlock,
    FilterPopup,
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const id = computed(() => {
      return props.id;
    });
    const activeIndex = ref(0);
    let page = 1;
    let total = 0;
    // 左侧分类
    const itemList = ref([]);
    const treeList = ref();
    // 右侧数据
    const catalogList = ref([]);
    const bookChild = ref();
    // 过滤值
    const filterPopup = ref();
		const showFilterPopup = ref(false)
		const facetList = ref([]);
    let filterParams = null;
    // 滚动位置
    let scrollTopTree = 0;
    let scrollTopBook = 0;
    onActivated(() => {
			treeList.value.$el.children[0].scrollTop = scrollTopTree; // 滚到之前的位置
			treeList.value.$el.children[1].scrollTop = scrollTopBook; // 滚到之前的位置
    })

    onBeforeRouteLeave((to, from) => {
      scrollTopTree = treeList.value.$el.children[0].scrollTop; // 记住滚动位置
      scrollTopBook = treeList.value.$el.children[1].scrollTop; // 记住滚动位置
    })

    const onClasses = () => {
      getClasses(id.value)
          .then(data => {
            if (isNotEmpty(data)) {
              data.forEach(item => {
                Object.assign(item, {text: item.clsName});
                itemList.value = data;
              });
              activeIndex.value = 0;
							catalogList.value = [];
              onBrowse();
            }
          })
          .catch((error) => {
            console.error(error);
          });
    };
    const onBrowse = () => {
      let params = filterParams ? new URLSearchParams(filterParams) : new URLSearchParams();
      params.append('page', page);
      params.append('pageSize', '20');
      browse(itemList.value[activeIndex.value].clsNo,params)
          .then(data => {
            if (data) {
            	const isbns = [];
              total = data.total;
              if (isNotEmpty(data.dataList)) {
                data.dataList.forEach(item => {
                  if (isNotEmpty(item.isbn)) {
                    isbns.push(item.isbn);
                  }
                });
                if(isNotEmpty(isbns)){
									setCovers(isbns, data.dataList);
								}
                catalogList.value = catalogList.value.concat(data.dataList);
              }
              page++;
              facetList.value = data.facetList ?? [];
            }
            if (isNotEmpty(bookChild.value)) {
              bookChild.value.loading = false; // 加载状态结束
              bookChild.value.finished = catalogList.value.length >= total;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    };
    const clickNav = () => {
      page = 1;
      catalogList.value = [];
      filterPopup.value?.reset(); // 清空筛选条件的选择
      filterParams = [];
      onBrowse();
    };
    const onLoad = () => {
      if (catalogList.value.length < total) {
        onBrowse();
      } else {
        bookChild.value.loading = false; // 加载状态结束
        bookChild.value.finished = catalogList.value.length >= total;
      }
    };
    // 处理过滤条件
    const getFilterParams = (params,showParams) => {
      filterParams = params;
      page =1;
      catalogList.value =[];
      onBrowse();
    }

    watch(
        id, () => {
          if (isNotEmpty(id.value)) {
            onClasses();
          }
        },
        {immediate: true}
    );
    return {
      activeIndex,
      catalogList,
      clickNav,
      itemList,
      bookChild,
      showFilterPopup,
      onLoad,
			getFilterParams,
			facetList,
      filterPopup,
      treeList
    };
  },
});
</script>

<style scoped lang="less">
@import "../assets/css/catalog-list.less";
</style>
